<template>
	<div class="flex h-full w-full flex-col items-center justify-center gap-2">
		<SoftTypography tag="h1" class="text-primary text-4xl">
			{{ t("notFound.title") }}
		</SoftTypography>
		<p>
			{{ t("notFound.description") }}
		</p>
		<SoftButton to="/" color="primary"> {{ t("notFound.button") }} </SoftButton>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "NotFound",
	setup() {
		const { t } = useI18n();
		return { t };
	},
});
</script>
